module.exports = __webpack_public_path__ + "img/6_18.db6cb61c.png";